<template>
  <section class="c4-idle">
    <span class="c4-qrtile" aria-hidden="true"><i class="mdi mdi-qrcode-scan"></i></span>
    <h2>{{ tx("idle.title") }}</h2>
    <div class="c4-idle-p">{{ tx("idle.sub") }}</div>
    <div class="c4-steps">
      <span class="c4-step"><i>1</i>{{ tx("idle.s1") }}</span>
      <span class="c4-step"><i>2</i>{{ tx("idle.s2") }}</span>
      <span class="c4-step"><i>3</i>{{ tx("idle.s3") }}</span>
    </div>
  </section>
</template>

<script>
import canteenV4Text from "@/mixins/canteenV4Text";

export default {
  name: "CanteenIdle",
  mixins: [canteenV4Text],
};
</script>
